.container {
	box-sizing: border-box;
	display: flex;
	border-radius: 5px;
	background-color: var(--ds-surface, var(--adg3-color-N0));
	position: absolute;
	box-shadow: var(--ds-shadow-raised, 0px 1px 5px 0px var(--adg3-color-N40));
	border: 1px solid var(--ds-border, var(--adg3-color-N40));
	flex-direction: column;
	cursor: pointer;
	padding: calc(var(--jpo-common-base-spacing) * 2) 0;
}

.items {
	display: flex;
	align-items: center;
	margin-bottom: var(--jpo-common-base-spacing);
	padding: var(--jpo-common-base-spacing);
	background-color: var(--ds-background-neutral, var(--adg3-color-N20));
	border-radius: 4px;
}

.items:last-child {
	margin-bottom: 0;
}

.header {
	padding: 0 calc(var(--jpo-common-base-spacing) * 2);
	margin-bottom: calc(var(--jpo-common-base-spacing) * 2);
	font-size: 14px;
	font-weight: 700;
}

.body {
	padding: 0 calc(var(--jpo-common-base-spacing) * 2);
	overflow: auto;
}

.icon {
	width: 16px;
	height: 16px;
	background-size: 16px 16px;
	margin-right: 10px;
	display: flex;
	flex-shrink: 0;
}

.issueLink {
	display: flex;
	flex-shrink: 0;
}

.breadcrumb {
	display: flex;
	font-size: 11px;
	margin-bottom: 10px;
}

.breadcrumbIcon {
	width: 14px;
	height: 14px;
	margin-right: 5px;
}

.dates {
	margin-top: 3px;
	font-size: 12px;
	color: var(--ds-text-subtlest, var(--adg3-color-N300));
}

.innerContent {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	overflow: auto;
}

.status {
	font-size: 12px;
	margin-top: 5px;
	margin-bottom: 3px;
}

.issueSummary {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding-left: 5px;
	flex-grow: 1;
	display: block;
}
